/**
 * LegalFooter — identifies the company that operates Backstop.
 *
 * Rendered once below the router so every route, signed in or not, carries
 * the operator's name, registry code and registered address.
 */

export function LegalFooter() {
  return (
    <footer class="border-line border-t bg-surface">
      <address class="text-surface-muted mx-auto max-w-4xl px-4 py-6 font-mono text-[11px] leading-relaxed not-italic tracking-[0.03em]">
        &copy; {new Date().getFullYear()} Backrank OÜ · Registry code 16949195
        <br />
        Tornimäe tn 3 // 5 // 7, Kesklinna linnaosa, 10145 Tallinn, Harju
        maakond, Estonia
      </address>
    </footer>
  );
}
